import React from 'react';
import { GiftIcon, SparklesIcon } from 'lucide-react';
export function BonusSection() {
  const scrollToCompra = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const bonuses = [{
    num: 1,
    title: '7 Técnicas Efectivas para Encontrar la Paz Mental',
    image: 'https://cdn.magicpatterns.com/uploads/cZH8y3gg4zD4ownDigT7Gh/portada_bonus_1.jpg'
  }, {
    num: 2,
    title: 'Rutina de 5 Minutos para Empezar el Día con Calma',
    image: 'https://cdn.magicpatterns.com/uploads/vqkNCH1qZ766MnEgyBDn5Q/portada_bonus.jpg'
  }];
  return <section className="bg-[#2a1f14] text-white py-20 px-4 border-t-4 border-[#c9a96e]" data-id="element-35">
      <div className="max-w-5xl mx-auto" data-id="element-36">
        {/* Header */}
        <div className="text-center mb-14" data-id="element-37">
          <div className="inline-flex items-center justify-center gap-3 bg-[#c9a96e] text-[#2a1f14] px-6 py-2 rounded-full font-oswald font-bold text-xl uppercase tracking-widest mb-6" data-id="element-38">
            <GiftIcon className="w-6 h-6" data-id="element-39" />
            De Regalo
          </div>
          <h2 className="font-oswald text-4xl md:text-6xl font-bold uppercase tracking-tight mb-4" data-id="element-40">
            Bonus exclusivos incluidos{' '}
            <span className="text-[#c9a96e]" data-id="element-41">HOY</span>
          </h2>
          <p className="font-opensans text-xl text-gray-300 max-w-2xl mx-auto" data-id="element-42">
            Además del programa completo, hoy te llevas estos bonus totalmente
            gratis
          </p>
        </div>

        {/* Bonus Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-14" data-id="element-43">
          {bonuses.map(bonus => <div key={bonus.num} className="bg-[#3d2e20] rounded-2xl border border-[#5a4535] shadow-2xl overflow-hidden group hover:border-[#c9a96e] transition-colors duration-300" data-id="element-44">
              {/* Bonus badge */}
              <div className="bg-[#c9a96e] text-[#2a1f14] py-2 px-4 font-oswald font-bold text-lg uppercase tracking-widest text-center flex items-center justify-center gap-2" data-id="element-45">
                <SparklesIcon className="w-5 h-5" data-id="element-46" />
                BONUS {bonus.num}
                <SparklesIcon className="w-5 h-5" data-id="element-47" />
              </div>

              {/* Image */}
              <div className="p-6 cursor-pointer" onClick={scrollToCompra} data-id="element-48">
                <div className="relative overflow-hidden rounded-xl" data-id="element-49">
                  <div className="absolute -inset-2 bg-[#c9a96e]/10 blur-xl rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" data-id="element-50"></div>
                  <img src={bonus.image} alt={bonus.title} className="relative w-full rounded-xl shadow-lg transform group-hover:scale-[1.02] transition-transform duration-500" data-id="element-51" />
                </div>
              </div>

              {/* Info */}
              <div className="px-6 pb-6" data-id="element-52">
                <h3 className="font-oswald text-xl md:text-2xl font-bold text-white uppercase mb-4 leading-tight" data-id="element-53">
                  {bonus.title}
                </h3>

                {/* Price */}
                <div className="flex items-center gap-4 mb-3" data-id="element-54">
                  <span className="font-oswald text-2xl text-gray-500 line-through decoration-[#b5634b] decoration-2" data-id="element-55">
                    $40.000
                  </span>
                  <div className="bg-[#c9a96e] text-[#2a1f14] px-4 py-2 rounded-lg" data-id="element-56">
                    <span className="font-oswald text-3xl font-bold" data-id="element-57">$0</span>
                  </div>
                </div>
                <p className="font-oswald text-xl font-bold text-[#c9a96e] uppercase tracking-wide" data-id="element-58">
                  ¡GRATIS HOY!
                </p>
              </div>
            </div>)}
        </div>

        {/* Bottom banner */}
        <div className="bg-[#c9a96e]/10 border-2 border-[#c9a96e] rounded-xl p-6 text-center animate-pulse" data-id="element-59">
          <p className="font-oswald text-2xl md:text-3xl font-bold text-[#c9a96e] uppercase tracking-wide" data-id="element-60">
            🎁 ESTOS BONUS SON GRATIS POR EL DÍA DE HOY 🎁
          </p>
        </div>
      </div>
    </section>;
}